import React from "react";
import HeroSection from "../../components/Home/HeroSection";
import ExpertSection from "../../components/Home/ExpertSection";
import PartnersSection from "../../components/Home/PartnersSection";
import ExpertiseSection from "../../components/Home/ExpertiseSection";
import ReseauSection from "../../components/Home/ReseauSection";
import TestimonialsSection from "../../components/Home/TestimonialsSection";
import Header from "../../components/appLayout/header";
import SEO from "../../components/SEO";

export const HomePage = () => {
  return (
    <div>
      <SEO
        title="MSIT Conseil - Expertise en Conseil et Transformation Digitale"
        description="MSIT Conseil est une société de conseil spécialisée en transformation digitale, intelligence artificielle, data et services technologiques. Expertise en conseil stratégique et opérationnel."
        keywords="conseil, transformation digitale, intelligence artificielle, data, services technologiques, MSIT, conseil stratégique, conseil opérationnel"
        url="https://www.msit-conseil.fr/"
      />
      <Header />
      <HeroSection /> 
      <ExpertSection />
      <PartnersSection />
      <ExpertiseSection /> 
      <ReseauSection />
      {/* <TestimonialsSection /> */}
    </div>
  );
};
